import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Share icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Share } from '@sravni/design-system-icons'
 *
 * <Share />
 * ```
 */
var Share = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Share", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.553 8.114a2.667 2.667 0 1 1-3.772 3.772 2.667 2.667 0 0 1 3.772-3.772ZM17.219 2.781a2.667 2.667 0 1 1-3.772 3.772 2.667 2.667 0 0 1 3.772-3.772ZM17.219 13.447a2.667 2.667 0 1 1-3.772 3.772 2.667 2.667 0 0 1 3.772-3.772ZM7.04 8.81l5.92-2.96M7.04 11.19l5.92 2.96", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Share };
//# sourceMappingURL=Share.js.map
